import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem;

  .info-box {
    background-color: #f0f0f0;
    padding: 1rem;
    border-radius: 4px;
    font-size: 0.9rem;
    color: #555;
    width: 100%;

    .MuiTypography-body2 {
      white-space: pre-line;
    }
  }

  .hardware-table {
    margin-top: 1rem;
    width: 100%;
  }

  .timer-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    margin: 1rem 0;
    width: 100%;
  }

  .timer {
    font-size: 2.5rem;
    font-weight: 500;
    font-family: "monospace";
    color: #333;
  }

  .analysis-period {
    width: 100%;
    text-align: center;
  }

  .analysis-times {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    color: #666;
  }

  .form-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .actions-container {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 1rem;
  }

  .result-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1rem;
    padding: 2rem;
    border: 1px solid #4caf50;
    border-radius: 8px;
    background-color: #f1f9f1;
  }

  .result-factor {
    font-size: 2.8rem;
    font-weight: bold;
    color: #4caf50;
  }

  .result-details {
    font-size: 0.9rem;
    color: #555;
  }
`;
